module.exports = __webpack_public_path__ + "img/prevpage.352e556c.svg";